import { render, staticRenderFns } from "./entity-results-panel.vue?vue&type=template&id=2441c2a2&"
import script from "./entity-results-panel.vue?vue&type=script&lang=ts&"
export * from "./entity-results-panel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2441c2a2')) {
      api.createRecord('2441c2a2', component.options)
    } else {
      api.reload('2441c2a2', component.options)
    }
    module.hot.accept("./entity-results-panel.vue?vue&type=template&id=2441c2a2&", function () {
      api.rerender('2441c2a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/powerbar/components/_entity-results-panel/entity-results-panel.vue"
export default component.exports